<template>
  <RouterView />
</template>

<script>
import { READ, CREATE, UPDATE } from '@/plugins/user'
export default {
  data () {
    return {
      breadcrumb: {
        name: new Promise(resolve => {
          this
            .$sdk
            .account
            .read(this.$route.params.accountId)
            .then(account => resolve(account.name))
        }),
        route: { name: 'sales-accounts-account', params: { accountId: this.$route.params.accountId } }
      },
      sidebar: [
        {
          icon: ['fal', 'chart-line'],
          route: { name: 'sales-accounts-account-dashboard', params: { accountId: this.$route.params.accountId } },
          name: 'Dashboard'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.account),
          icon: ['fal', 'file-user'],
          route: { name: 'sales-accounts-account-details', params: { accountId: this.$route.params.accountId } },
          name: 'Details'
        },
        {
          hidden: this.$user.cannot([READ, CREATE, UPDATE], this.$sdk.account_event),
          icon: ['fal', 'tasks'],
          route: { name: 'sales-accounts-account-todo', params: { accountId: this.$route.params.accountId } },
          name: 'To-Do'
        },
        {
          hidden: this.$user.cannot(UPDATE, this.$sdk.account),
          icon: ['fal', 'cogs'],
          route: { name: 'sales-accounts-account-configure', params: { accountId: this.$route.params.accountId } },
          name: 'Configure'
        },
        {
          hidden: this.$user.cannot([READ, UPDATE], 'account_attachment'),
          icon: ['fal', 'box-open'],
          route: { name: 'sales-accounts-account-trackingservices', params: { accountId: this.$route.params.accountId } },
          name: 'Track My Parcel'
        },
        {
          hidden: this.$user.cannot(READ, 'account_carriersetting'),
          icon: ['fal', 'person-carry'],
          route: { name: 'sales-accounts-account-carriers', params: { accountId: this.$route.params.accountId } },
          name: 'Carriers'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.account_event),
          icon: ['fal', 'history'],
          route: { name: 'sales-accounts-account-histories', params: { accountId: this.$route.params.accountId } },
          name: 'Histories'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.pickup),
          icon: ['fal', 'person-dolly'],
          route: { name: 'sales-accounts-account-pickups', params: { accountId: this.$route.params.accountId } },
          name: 'Pickups'
        },
        {
          hidden: this.$user.cannot(READ, this.$sdk.account_contact),
          icon: ['fal', 'address-book'],
          route: { name: 'sales-accounts-account-contacts', params: { accountId: this.$route.params.accountId } },
          name: 'Contacts'
        },
        {
          hidden: this.$user.cannot(READ, 'account_attachment'),
          icon: ['fal', 'paperclip'],
          route: { name: 'sales-accounts-account-attachments', params: { accountId: this.$route.params.accountId } },
          name: 'Attachments'
        },
        {
          hidden: this.$user.cannot(READ, 'account_note'),
          icon: ['fal', 'comment-alt'],
          route: { name: 'sales-accounts-account-notes', params: { accountId: this.$route.params.accountId } },
          name: 'Notes'
        },
        {
          icon: ['fal', 'file-invoice'],
          route: { name: 'sales-accounts-account-invoices', params: { accountId: this.$route.params.accountId } },
          name: 'Invoices'
        }
      ]
    }
  }
}
</script>
